import React, { useEffect, useState, useContext } from 'react'
import { PlayerProfileContext } from '../../../../../Context'
import { PlayersAllSeasonStatsData } from '../../../../../Api/Players/player.types'
import {
  ConvertStatValue,
  mapPlayerSeasonStatHeaders,
  convertTeamId,
  determineStatAvg,
} from '../../../../../Utils'
import { SeasonAveragesRow, SeasonDataRow, SeasonTable, SeasonTableCon } from '../styles'
import { TableHeader } from '../../../../../Components/Tables/TableHeader'

export const SeasonStatsTable: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player } = useContext(PlayerProfileContext)!
  const [seasonStats, setSeasonStats] = useState<PlayersAllSeasonStatsData[]>([])
  const position = player?.currentTeam?.position
  const fields = mapPlayerSeasonStatHeaders(position)

  useEffect(() => {
    if (player?.allSeasonStats && player.allSeasonStats.length > 0) {
      setSeasonStats(player.allSeasonStats)
    }
  }, [player])

  return (
    <SeasonTableCon>
      {seasonStats.length > 0 && (
        <SeasonTable>
          <thead className="headRow">
            <tr>
              <TableHeader ariaLabel="Season"></TableHeader>
              <TableHeader ariaLabel="Team">Team</TableHeader>
              {Object.values(fields).map((v, i) => (
                <TableHeader key={i} ariaLabel={v[0]}>{v[0]}</TableHeader>
              ))}
            </tr>
          </thead>
          <tbody>
            {seasonStats.map((row, idx) => (
              <SeasonDataRow key={idx}>
                <td>{row.year}</td>
                <td>
                  {row.teamId && row.year ? convertTeamId(row.teamId, row.year) : ''}
                </td>
                {Object.values(fields).map((v, i) => (
                  <td key={i}>
                    {ConvertStatValue(
                      row[v[2] as keyof PlayersAllSeasonStatsData],
                      v[2]
                    )}
                  </td>
                ))}
              </SeasonDataRow>
            ))}
            <SeasonAveragesRow>
              <td></td>
              <td>Averages</td>
              {Object.values(fields).map((v) => (
                <td key={v[0]}>{determineStatAvg(v[2], seasonStats)}</td>
              ))}
            </SeasonAveragesRow>
          </tbody>
        </SeasonTable>
      )}
    </SeasonTableCon>
  )
}
